import React, { useState, useEffect } from "react"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import moment from "moment"
import { MdClose, MdKeyboardArrowDown } from "react-icons/md"
import { FaRegCalendar } from "react-icons/fa"
import tw from "tailwind-styled-components"
import { ActionSection, CardWrapper, FieldWrappers, InputGroup, Label, ScrollableContent, SelectionCard, SideCancelBtn, SubmitBtn, Wrapper } from "../Styles/InputStyles"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import Images from "../../Images"

export default function DateRepetitionModal({
    isOpen,
    onClose,
    onSave,
    initialDate,
    initialRepetition,
    initialNoOfMonths,
}) {

    const [selectedDate, setSelectedDate] = useState(
        initialDate ? new Date(initialDate) : null
    )

    const [selectedDueDate, setSelectedDueDate] = useState(
        initialDate ? new Date(initialDate) : null
    )      
    const [repetitionType, setRepetitionType] = useState(initialRepetition)
    const [monthsToRepeat, setMonthsToRepeat] = useState(initialNoOfMonths)
    const [calendarOpen, setCalendarOpen] = useState(false)

    useEffect(() => {
        setSelectedDate(initialDate ? new Date(initialDate) : null)
        setRepetitionType(initialRepetition)
        setMonthsToRepeat(initialNoOfMonths)
    }, [initialDate, initialRepetition, initialNoOfMonths])

    if (!isOpen) return null

    const handleSave = () => {
        if (!selectedDate) {
            alert("Please select an expense date.")
            return
        }
        if (!repetitionType) {
            alert("Please select a repetition type.")
            return
        }
        if (repetitionType === 2 && (!monthsToRepeat || monthsToRepeat <= 0)) {
            alert("Please select a valid number of months for repetition.")
            return
        }

        onSave(
            moment(selectedDate).format("YYYY-MM-DD"),
            repetitionType,
            repetitionType === 2 ? monthsToRepeat : null,
            moment(selectedDueDate).format("YYYY-MM-DD"),
        )
        onClose()
    }

    return (
        <Overlay>
            <ModalWrapper>
                <Header>
                    <ModalTitle>Select Date & Repetition</ModalTitle>
                    <button onClick={onClose} className="text-white">
                        <MdClose size={24} />
                    </button>
                </Header>
                <div className="custom-scrollbar flex h-full flex-col justify-between px-6">
                    <ScrollableContent className="!max-h-[calc(100vh-140px)]">
                        <Wrapper>
                            <InputGroup>
                                <Label htmlFor="expenseDate">
                                    Select Expense Date *
                                </Label>

                                <div className="relative w-full">
                                    <DatePicker
                                        selected={selectedDate}
                                        onChange={(date) => setSelectedDate(date)}
                                        inline
                                        dateFormat="yyyy-MM-dd"
                                        required
                                        id="expenseDate"
                                        autoComplete="off"
                                        className="w-full"
                                    />
                                </div>

                            </InputGroup>
                            <InputGroup>
                                <Label>
                                    Is this a one-time expense or a recurring expense? *
                                </Label>
                                <CardWrapper>
                                    <SelectionCard
                                        type="button"
                                        onClick={() => setRepetitionType(1)}
                                        className={
                                            repetitionType === 1
                                                ? "bg-primary-color text-white"
                                                : "bg-gray-100"
                                        }
                                    >
                                        <span className="text-sm ">{"One Time"}</span>
                                    </SelectionCard>
                                    <SelectionCard
                                        type="button"
                                        onClick={() => setRepetitionType(2)}
                                        className={
                                            repetitionType === 2
                                                ? "bg-primary-color text-white"
                                                : "bg-gray-100"
                                        }
                                    >

                                        <span className="text-sm ">{"Recurring"}</span>
                                    </SelectionCard>
                                </CardWrapper>
                            </InputGroup>
                            {repetitionType === 2 && (
                                <InputGroup>
                                    <Label htmlFor="monthsToRepeat">
                                        After how many months should this expense repeat? *
                                    </Label>
                                    <Select
                                        value={monthsToRepeat || ""}
                                        onChange={(e) => setMonthsToRepeat(e.target.value)}
                                        displayEmpty
                                        inputProps={{ 'aria-label': 'Select months' }}
                                        className="w-full px-2"
                                        style={{ height: "46px" }}
                                    >
                                        <MenuItem value="" disabled>
                                            Select months
                                        </MenuItem>
                                        {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                                            <MenuItem key={month} value={month}>
                                                {month} {month === 1 ? 'month' : 'months'}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </InputGroup>
                            )}
                            <InputGroup>
                                <Label htmlFor="dueDate">
                                    Expense Month (belongs to)
                                </Label>

                                <div className="relative w-full">
                                    <DatePicker
                                        selected={selectedDueDate}
                                        onChange={(date) => setSelectedDueDate(date)}
                                        dateFormat="MMMM yyyy"
                                        showMonthYearPicker
                                        className="react-datepicker-input block border border-gray-400 p-2 w-full rounded-md h-11 bg-white cursor-pointer pl-8"
                                        maxDate={new Date()}
                                        //onFocus={(e) => e.target.blur()}
                                        showFullMonthYearPicker
                                        showTwoColumnMonthYearPicker
                                        onClickOutside={() => setCalendarOpen(false)}
                                        onSelect={() => setCalendarOpen(false)}
                                        open={calendarOpen}
                                        onInputClick={() => setCalendarOpen(true)}
                                        showPopperArrow={false}
                                        portalId="root-portal"
                                        popperClassName="react-datepicker-popper"
                                    />
                                    <img
                                        src={Images.Calender}
                                        alt="Calender icon"
                                        className="w-4 absolute left-2 top-3 text-gray-500"
                                    />
                                    <MdKeyboardArrowDown
                                        className="absolute right-2 top-3 md:block hidden text-gray-500"
                                        style={{ fontSize: "18px", cursor: "pointer" }}
                                    />
                                </div>

                            </InputGroup>
                        </Wrapper>
                    </ScrollableContent>
                </div>
                <ActionSection>
                    <SideCancelBtn type="button" onClick={onClose}>
                        Cancel
                    </SideCancelBtn>
                    <SubmitBtn type="button" onClick={handleSave}>
                        OK
                    </SubmitBtn>
                </ActionSection>
            </ModalWrapper>
        </Overlay>
    )
}
// Styled wrappers using tailwind-styled-components
const Overlay = tw.div`fixed inset-0 z-50 flex items-center justify-end bg-black/50 `
const ModalWrapper = tw.div`bg-white w-11/12 h-full flex flex-col relative `
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`
const ModalTitle = tw.h2`text-lg font-medium text-white`
const Input = tw.input`w-full rounded-md border border-gray-300 p-2 focus:border-blue-500 focus:ring-blue-500`
